export default __webpack_public_path__ + "static/media/ic_svg_exito.b21e7dea.svg";